import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { BarChart, Bar } from "recharts";
import tiempoConv from "../../../data/conv/tiempo_conv.json";
import estadoConv from "../../../data/conv/estado_conv.json";
import DepartamentoConv from "../../../data/conv/departamento_conv.json";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const Graficos = () => {
  return (
    <div>
      <Typography
        variant="h4"
        align="center"
        padding="20px"
        sx={{ fontWeight: "bold ", color: "#081d4b" }}
      >
        Convocatorias
      </Typography>
      <Typography variant="body1" align="center" gutterBottom>
        {" "}
        (de Enero de 2012 a Diciembre de 2022)
      </Typography>

      <Grid container item spacing={2} display="flex" align="center">
        <Grid item xs={12} width={500}>
          <Typography
            variant="subtitle1"
            gutterBottom
            align="center"
            sx={{ fontWeight: "bold ", color: "#081d4b" }}
          >
            Cantidad de Convocatorias
          </Typography>
          <ResponsiveContainer width="70%" height={300}>
            <LineChart
              data={tiempoConv}
              fontFamily={"Roboto, sans-serif"}
              margin={{
                top: 20,
                right: 30,
                left: 30,
                bottom: 5,
              }}
            >
              <Line
                type="monotone"
                dataKey="n_conv"
                stroke="#081D4B"
                strokeWidth={4}
                animationBegin={1000}
                animationDuration={3000}
              />
              <CartesianGrid stroke="#ccc" strokeDasharray="6 6" />
              <XAxis dataKey="mes" />
              <YAxis />
              <Tooltip />
            </LineChart>
          </ResponsiveContainer>
        </Grid>

        <Grid item xs={12}>
          <Typography
            variant="subtitle1"
            gutterBottom
            align="center"
            sx={{ fontWeight: "bold ", color: "#081d4b" }}
          >
            Departamento de Convocatorias
          </Typography>
          <ResponsiveContainer width="70%" height={270}>
            <BarChart
              data={DepartamentoConv}
              fontFamily={"Roboto, sans-serif"}
              margin={{
                top: 20,
                right: 30,
                left: 30,
                bottom: 5,
              }}
            >
              <XAxis dataKey="departamento" />
              <YAxis />
              <Bar
                dataKey="n"
                barSize={70}
                fill="#081D4B"
                animationBegin={2000}
                animationDuration={3000}
              />
              <Tooltip />
            </BarChart>
          </ResponsiveContainer>
        </Grid>

        <Grid item xs={12} marginBottom={2}>
          <Typography
            variant="subtitle1"
            gutterBottom
            align="center"
            sx={{ fontWeight: "bold ", color: "#081d4b" }}
          >
            Estado de Convocatorias
          </Typography>
          <ResponsiveContainer width="70%" height={270}>
            <BarChart
              data={estadoConv}
              fontFamily={"Roboto, sans-serif"}
              margin={{
                top: 20,
                right: 30,
                left: 30,
                bottom: 5,
              }}
            >
              <XAxis dataKey="tema" />
              <YAxis />
              <Bar
                dataKey="n"
                barSize={80}
                fill="#081D4B"
                animationBegin={2000}
                animationDuration={3000}
              />
              <Tooltip />
            </BarChart>
          </ResponsiveContainer>
        </Grid>
      </Grid>
    </div>
  );
};

export default Graficos;
